import React from 'react'
import styled from 'styled-components'

function Copyright() {
  return (
    <Container>
        © {(new Date().getFullYear())} Colton Cobi. 30716337452. Todos los derechos reservados.
    </Container>
  )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    color: ${(props) => props.theme.copyright};
    text-align: center;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
`

export default Copyright